import script from "./CollectFolderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectFolderDetail.vue?vue&type=script&setup=true&lang=js"

import "./CollectFolderDetail.vue?vue&type=style&index=0&id=39b5886a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b5886a"]])

export default __exports__